import React, { useState, useEffect } from 'react';
import BlogCard from './BlogCard';
import blogPosts from '../data/blogData';
import SeoHelmet from "../components/SeoHelmet";


import extra from "../assets/img/blog/extra.png";
import Clip from "../assets/img/blog/Clip.png";
import Blog1 from "../assets/img/blog/blog1.png";
import Blog2 from "../assets/img/blog/blog2.png";
import Insta from "../assets/img/blog/insta.png";
import Arrow from "../assets/img/blog/arrow.png";

const Blog = () => {
  const postsPerPage = 9;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(blogPosts.length / postsPerPage);
  const startIdx = (currentPage - 1) * postsPerPage;
  const selectedPosts = blogPosts.slice(startIdx, startIdx + postsPerPage);

  // Utility: Group posts into chunks of 3
  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  useEffect(() => {
      document.body.classList.add('blogmbr');
  
      return () => {
        document.body.classList.remove('blogmbr');
      };
    }, []);

  const chunkedPosts = chunkArray(selectedPosts, 3); // each row has 1 big + 2 small

  return (
      <>
      <SeoHelmet />
      <section className='blog_part'>
         <div className='border_mbr blog_bar'></div>
        <div className='blog_content'>
          <img src={extra} className='extraimg'></img>
          <div className='border_mbr'></div>
          <h2>New Blog</h2>
        </div>
        <div className='discover_text'>
          <div className='border_mbrr'></div>
            <h3><img src={Clip}></img> DISCOVER BHAVNA’S NEWEST COLLECTOR EDITION ACCESORIES <img src={Clip}></img></h3>
            <div className='border_mbrb'></div>
        </div>

        <div className='blog_part_content'>
          <div className='blog_left'>
            <h3>Launching December 2026</h3>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unc</p>
            <div className='border_mbrb'></div>
          </div>
          <div className='blog_imgma'>
            <img className='about_icon' src={Blog1} ></img>
             <img className='about_icon1' src={Blog2} ></img>
          </div>
          <div className='blog_right'>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unc</p>
            <h3>Don't Miss Out & Stay Updated</h3>
            <div className='border_mbrb'></div>
          </div>
        </div>
        <div className='discover_text dicinstat'>
          <h3><img src={Arrow}></img> <span>More Contant At<img src={Insta} className='instabhav'></img> Bhavna555</span> <img src={Arrow}></img></h3>
        </div>
        <div className='discover_text'>
          <div className='border_mbrr'></div>
            <h3><img src={Clip}></img> DISCOVER BHAVNA’S NEWEST COLLECTOR EDITION ACCESORIES <img src={Clip}></img></h3>
            <div className='border_mbrb'></div>
        </div>
        <div className='discover_text'>
         
            <h3><img src={Clip}></img> DISCOVER BHAVNA’S NEWEST COLLECTOR EDITION ACCESORIES <img src={Clip}></img></h3>
            <div className='border_mbrb'></div>
        </div>



      </section>




    {/* <section className="blog">
      <div className="container">
        {chunkedPosts.map((chunk, rowIndex) => {
          const [bigPost, smallPost1, smallPost2] = chunk;
          const isEven = rowIndex % 2 === 0;

          return (
            
            <div className="row" key={bigPost.id}>
              {isEven ? (
                // Even row: Big left, small right
                <>
                  <div className="col-sm-5">
                    <BlogCard post={bigPost} height="690px" />
                  </div>
                  <div className="col-sm-7">
                    {smallPost1 && (
                      <BlogCard post={smallPost1} height="330px" style={{ marginBottom: '30px' }} />
                    )}
                    {smallPost2 && (
                      <BlogCard post={smallPost2} height="330px" />
                    )}
                  </div>
                </>
              ) : (
                // Odd row: Small left, big right
                <>
                  <div className="col-sm-7">
                    {smallPost1 && (
                      <BlogCard post={smallPost1} height="330px" style={{ marginBottom: '30px' }} />
                    )}
                    {smallPost2 && (
                      <BlogCard post={smallPost2} height="330px" />
                    )}
                  </div>
                  <div className="col-sm-5">
                    <BlogCard post={bigPost} height="690px" />
                  </div>
                </>
              )}
            </div>
          );
        })}

       
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              onClick={() => setCurrentPage(i + 1)}
              style={{
                  margin: '0 5px',
                  padding: '8px 12px',
                  background: 'transparent',
                  color: '#fff',
                  border: 'none',
                  borderBottom: currentPage === i + 1 ? '2px solid #fff' : '2px solid transparent',
                  fontWeight: currentPage === i + 1 ? 'bold' : 'normal',
                  cursor: 'pointer',
                }}
            >
              {i + 1}
            </button>
          ))} 
        </div>
      </div>
    </section> */}
    </>
  );
};

export default Blog;
